import React, { useState, useMemo } from 'react';
import { Button } from '@/components/ui/button';
import { Package } from '@phosphor-icons/react';
import SearchFilterBar, { filterRecords } from '@/components/SearchFilterBar';

export const VendorOrdersPanel = ({ vendorOrders, onMarkReady }) => {
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('all');

  const filtered = useMemo(
    () => filterRecords(vendorOrders, { keyword, statusValue: status, fields: ['vendor_name'] }),
    [vendorOrders, keyword, status]
  );

  return (
    <div className="space-y-3">
      <SearchFilterBar
        keyword={keyword} onKeywordChange={setKeyword}
        statusValue={status} onStatusChange={setStatus}
        statusOptions={[
          { value: 'accumulating', label: 'Accumulating' },
          { value: 'ready_for_po', label: 'Ready for PO' },
          { value: 'po_created', label: 'PO Created' },
          { value: 'completed', label: 'Completed' },
        ]}
        onClear={() => { setKeyword(''); setStatus('all'); }}
        placeholder="Search vendor…"
        testIdPrefix="ops-orders-filter"
      />
      <div className="grid gap-4">
        {filtered.length === 0 && (
          <div className="p-6 text-center text-text-tertiary bg-white border border-border-default rounded">
            No matching vendor orders.
          </div>
        )}
        {filtered.map((order) => (
          <div key={order.id} className="border border-border-default rounded p-6" data-testid={`vendor-order-${order.id}`}>
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-accent-brand-subtle flex items-center justify-center">
                  <Package size={24} className="text-accent-brand" weight="duotone" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-text-primary">{order.vendor_name}</h3>
                  <p className="text-text-secondary">{order.requisition_ids.length} items • ₹{order.total_amount.toFixed(2)}</p>
                  <p className="text-sm text-text-tertiary mt-1">
                    Deadline: {new Date(order.order_deadline).toLocaleDateString()}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <span className={`status-badge ${order.status === 'accumulating' ? 'status-pending' : 'status-info'}`}>
                  {order.status.replace(/_/g, ' ')}
                </span>
                {order.status === 'accumulating' && (
                  <Button
                    size="sm"
                    className="mt-2 bg-accent-brand hover:bg-accent-brand-hover text-white"
                    onClick={() => onMarkReady(order.id)}
                    data-testid={`mark-ready-${order.id}`}
                  >
                    Mark Ready for PO
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VendorOrdersPanel;
